<div class="chip"  [attr.data-qa]="testIdPrefix">
   {{label}}
  <rx-icon  [attr.data-qa]="testIdPrefix + '-delete'" (click)="removeChip($event)" name="close"  class="ml-2 chip__icon"/>
</div>
